import { ForwardedRef, forwardRef } from 'react';
import { HBActionAreaProps } from './HBActionArea.types';
import React from 'react';
import { ActionAreaButton } from './HBActionArea.styles';

export const HBActionArea = forwardRef<HTMLButtonElement, HBActionAreaProps>(
    (
        { children, 'data-testid': dataTestId = 'hb-action-area', ...props },
        ref: ForwardedRef<HTMLButtonElement>
    ) => {
        return (
            <ActionAreaButton
                testId={dataTestId}
                data-is-empty={!children}
                ref={ref}
                type="button"
                tag="button"
                {...props}
            >
                {children}
            </ActionAreaButton>
        );
    }
);

export default HBActionArea;
